import { Progress } from '@base-ui/react/progress'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ProgressValueProps extends PartProps<Progress.Value.Props> {
  className?: string
}

function ProgressValue({ className, children, ...props }: ProgressValueProps) {
  return (
    <Progress.Value
      className={twMerge('text-foreground-secondary col-start-2 text-right text-sm', className)}
      {...props}
    >
      {children}
    </Progress.Value>
  )
}

export { ProgressValue }
